var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5C11.2031 4.5 7.78125 6.51562 5.90625 9.75C3.98438 13.0312 3.98438 17.0156 5.90625 20.25C7.78125 23.5312 11.2031 25.5 15 25.5C18.75 25.5 22.1719 23.5312 24.0469 20.25C25.9688 17.0156 25.9688 13.0312 24.0469 9.75C22.1719 6.51562 18.75 4.5 15 4.5ZM15 27C10.6875 27 6.75 24.75 4.59375 21C2.4375 17.2969 2.4375 12.75 4.59375 9C6.75 5.29688 10.6875 3 15 3C19.2656 3 23.2031 5.29688 25.3594 9C27.5156 12.75 27.5156 17.2969 25.3594 21C23.2031 24.75 19.2656 27 15 27ZM12.75 19.5H14.25V15H13.125C12.7031 15 12.375 14.6719 12.375 14.25C12.375 13.875 12.7031 13.5 13.125 13.5H15C15.375 13.5 15.75 13.875 15.75 14.25V19.5H17.25C17.625 19.5 18 19.875 18 20.25C18 20.6719 17.625 21 17.25 21H12.75C12.3281 21 12 20.6719 12 20.25C12 19.875 12.3281 19.5 12.75 19.5ZM15 11.625C14.3438 11.625 13.875 11.1562 13.875 10.5C13.875 9.89062 14.3438 9.375 15 9.375C15.6094 9.375 16.125 9.89062 16.125 10.5C16.125 11.1562 15.6094 11.625 15 11.625Z",
    fill: "#0D2EA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBorder);
export default __webpack_public_path__ + "static/media/info-border.b601d7b4438d43af7c2b8ba1a16ab4f1.svg";
export { ForwardRef as ReactComponent };